import {isLocal, saveToLocalStorage} from 'helper-func'
let urlDefault = isLocal() ? ('http://localhost:5000/z2api/rest/') : (document.location.origin + '/z2api/rest/')

let apiDichCode = 111060111
let fastAnswer401 = {code: 401}
let fastAnswer500 = {code: 500}
let hd = {'Content-Type': 'application/json'}

/* 0. Общие */
/* 0.1. Выход */
let apiAlert = async (message = {}, code = apiDichCode) => {
    const formData = new FormData()
    formData.append('code', code)
    formData.append('ver', 56467)
    formData.append('message', JSON.stringify({'aUrl': ((!!document.location.href && document.location.href + '' !== '') ? document.location.href + '' : '-'), message: message}).substring(0, 1000).replace(/\\/g, ""))

    // try {await fetch((urlDefault + 'alert'), {"method": "POST", "body": formData})} catch (_) {}
    // await req({method: (urlDefault + 'alert'), body: {"method": 'POST', "body": formData}})
}
/* 0.1. Выход */
let apiExit = async () => {localStorage.removeItem('authData'); return await req({method: urlDefault + 'logout', body: {method: 'GET'}})}
/* 0.2. Вход */
let apiAuth = async (params = {}) => {return await req({method: urlDefault + 'auth', body: {method: 'POST', headers: hd, body: JSON.stringify(params)}})}
/* 0.3. Восстановление */
let apiRecovery = async (params = {}) => {return await req({method: urlDefault + 'recovery-password', body: {method: 'POST', headers: hd, body: JSON.stringify(params)}})}
/* 0.4. Новый пароль */
let apiNewPassword = async (params = {}) => {return await req({method: urlDefault + 'recovery-password', body: {method: 'PUT', headers: hd, body: JSON.stringify(params)}})}

/* 1. Подписки */
/* 1.1. Получить список */
let apiSubs = async (params) => {
    if (!localStorage.getItem('authData')) {return fastAnswer401}
    let addUrlParam = ''
    const pageSize = parseInt(params?.itemsInPage ?? 10, 10)
    if (params) {
        // if (params.id && params.id !== '') {addUrlParam += '&id=' + params.id}
        if (params.idLike && params.idLike !== '') {addUrlParam += '&idLike=' + params.idLike}
        if (params.email && params.email !== '') {addUrlParam += '&email=' + params.email}

        if (params.companyName && params.companyName !== '') {addUrlParam += '&companyName=' + params.companyName}
        if (params.companyCode && params.companyCode !== '') {addUrlParam += '&companyCode=' + params.companyCode}
        if (params.agreementNumber && params.agreementNumber !== '') {addUrlParam += '&agreementNumber=' + params.agreementNumber}

        if (params.status && params.status !== '') {addUrlParam += '&status=' + params.status}
        if (params.date_from && params.date_from !== '') {addUrlParam += '&dateFrom=' + params.date_from}
        if (params.date_to && params.date_to !== '') {addUrlParam += '&dateTo=' + params.date_to}
        if (params.csv && params.csv !== '') {addUrlParam += '&csv=' + params.csv}
    }
    addUrlParam += '&offset=' + (Math.max(parseInt(params?.page ?? 1, 10), 1) - 1).toString()
    addUrlParam += '&limit=' + pageSize.toString()
    addUrlParam = urlDefault + 'subscriptions' + (params?.id && params.id !== '' ? ('/' + params.id) : '') + '?' + addUrlParam
    addUrlParam = addUrlParam.split('?=&').join('?').split('?&').join('?')
    return await req({method: addUrlParam, body: {method: 'GET' }})
}
let apiSubsCheck = (apiData) => {
    let isBreak = 0
    let outErr = []
    let outCode = 0
    let outId = ''
    if (apiData.code !== 200) {
        outCode = apiData.code
    } else {
        try {
            if (typeof(apiData.data) !== "object") {outErr.push({data: "type"})} else {
                if (apiData.data.length > 0) {
                    Object.keys(apiData.data).forEach(item => {
                        if (isBreak < 5) {
                            // console.log(apiData.data[item])

                            if (!apiData.data[item].activated) {outErr.push({activated: "not found"})} else {
                                if (typeof(apiData.data[item].activated) !== "number") {outErr.push({activated: "type"})} else {
                                    if (([0,1,null]).indexOf(apiData.data[item].activated) === -1) {
                                        outErr.push({activated: "value"})
                                    }
                                }
                            }

                            if (!apiData.data[item].activation) {outErr.push({activation: "not found"})} else {
                                if (typeof(apiData.data[item].activation) !== "object") {outErr.push({activation: "type"})} else {
                                    //
                                    if (!apiData.data[item].activation.code) {outErr.push({activation_code: "not found"})} else {
                                        if (typeof(apiData.data[item].activation.code) !== "string") {outErr.push({activation_code: "type"})} else {
                                            if ((apiData.data[item].activation.code).toString().length !== 23) {
                                                outErr.push({activation_code: "length", value: apiData.data[item].activation.code})
                                            }
                                        }
                                    }
                                    //
                                }
                            }

                            if (!apiData.data[item].agreementNumber) {outErr.push({agreementNumber: "not found"})} else {
                                if (typeof(apiData.data[item].agreementNumber) !== "string") {outErr.push({agreementNumber: "type"})} else {
                                    if ((apiData.data[item].agreementNumber).toString().length !== 8) {
                                        outErr.push({agreementNumber: "length", value: apiData.data[item].agreementNumber})
                                    }
                                }
                            }

                            if (!apiData.data[item].autoSuspend) {} else {
                                if (typeof(apiData.data[item].autoSuspend) !== "number") {outErr.push({autoSuspend: "type"})} else {
                                    if (([0,1,null]).indexOf(apiData.data[item].autoSuspend) === -1) {
                                        outErr.push({autoSuspend: "value", value: apiData.data[item].autoSuspend})
                                    }
                                }
                            }

                            if (!apiData.data[item].chargingNextTime) {outErr.push({chargingNextTime: "not found"})} else {
                                if (typeof(apiData.data[item].chargingNextTime) !== "string") {outErr.push({chargingNextTime: "type"})} else {
                                    if ((apiData.data[item].chargingNextTime).toString().length !== 24) {
                                        outErr.push({chargingNextTime: "length", value: apiData.data[item].chargingNextTime})
                                    }
                                }
                            }

                            if (!apiData.data[item].createdAt) {outErr.push({createdAt: "not found"})} else {
                                if (typeof(apiData.data[item].createdAt) !== "string") {outErr.push({createdAt: "type"})} else {
                                    if ((apiData.data[item].createdAt).toString().length !== 24) {
                                        outErr.push({createdAt: "length", value: apiData.data[item].createdAt})
                                    }
                                }
                            }

                            if (!apiData.data[item].customData) {outErr.push({customData: "not found"})} else {
                                if (typeof(apiData.data[item].customData) !== "object") {outErr.push({customData: "type"})} else {
                                    //
                                    if (!apiData.data[item].customData.rowTotal) {outErr.push({customData_rowTotal: "not found"})} else {
                                        if (typeof(apiData.data[item].customData.rowTotal) !== "number") {outErr.push({customData_rowTotal: "type"})} else {
                                            if (([2352]).indexOf(apiData.data[item].customData.rowTotal) === -1) {
                                                outErr.push({customData_rowTotal: "value", value: apiData.data[item].customData.rowTotal})
                                            }
                                        }
                                    }
                                    //
                                }
                            }

                            if (!apiData.data[item].customer) {outErr.push({customer: "not found"})} else {
                                if (typeof(apiData.data[item].customer) !== "object") {outErr.push({customer: "type"})} else {
                                    //
                                    if (!apiData.data[item].customer.description) {} else {
                                        if (typeof(apiData.data[item].customer.description) !== "string") {outErr.push({customer_description: "type"})}
                                    }
                                    if (!apiData.data[item].customer.name) {} else {
                                        if (typeof(apiData.data[item].customer.name) !== "string") {outErr.push({customer_name: "type"})}
                                    }
                                    if (!apiData.data[item].customer.id) {outErr.push({customer_id: "not found"})} else {
                                        if (typeof(apiData.data[item].customer.id) !== "string") {outErr.push({customer_id: "type"})} else {
                                            if ((apiData.data[item].customer.id).toString().length !== 36) {
                                                outErr.push({customer_id: "length", value: apiData.data[item].customer.id})
                                            }
                                        }
                                    }
                                    if (!apiData.data[item].customer.options) {outErr.push({customer_options: "not found"})} else {
                                        if (typeof(apiData.data[item].customer.options) !== "object") {outErr.push({customer_options: "type"})} else {
                                            if (!apiData.data[item].customer.options.company) {outErr.push({customer_options_company: "not found"})} else {
                                                if (typeof(apiData.data[item].customer.options.company) !== "object") {outErr.push({customer_options_company: "type"})} else {
                                                    //-//
                                                    if (!apiData.data[item].customer.options.company.address) {outErr.push({customer_options_company_address: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.company.address) !== "string") {outErr.push({customer_options_company_address: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.code) {outErr.push({customer_options_company_code: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.company.code) !== "string") {outErr.push({customer_options_company_code: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.fax) {} else {
                                                        if (typeof(apiData.data[item].customer.options.company.fax) !== "string") {outErr.push({customer_options_company_fax: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.kpp) {} else {
                                                        if (typeof(apiData.data[item].customer.options.company.kpp) !== "string") {outErr.push({customer_options_company_kpp: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.name) {outErr.push({customer_options_company_name: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.company.name) !== "string") {outErr.push({customer_options_company_name: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.phone) {} else {
                                                        if (typeof(apiData.data[item].customer.options.company.phone) !== "string") {outErr.push({customer_options_company_phone: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.company.website) {} else {
                                                        if (typeof(apiData.data[item].customer.options.company.website) !== "string") {outErr.push({customer_options_company_website: "type"})}
                                                    }
                                                    //-//
                                                }
                                            }
                                            if (!apiData.data[item].customer.options.contacts) {outErr.push({customer_options_contacts: "not found"})} else {
                                                if (typeof(apiData.data[item].customer.options.contacts) !== "object") {outErr.push({customer_options_contacts: "type"})} else {
                                                    //-//
                                                    if (!apiData.data[item].customer.options.contacts.city) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.city) !== "string") {outErr.push({customer_options_contacts_city: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.country) {outErr.push({customer_options_contacts_country: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.country) !== "string") {outErr.push({customer_options_contacts_country: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.email) {outErr.push({customer_options_contacts_email: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.email) !== "string") {outErr.push({customer_options_contacts_email: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.fax) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.fax) !== "string") {outErr.push({customer_options_contacts_fax: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.job) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.job) !== "string") {outErr.push({customer_options_contacts_job: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.name) {outErr.push({customer_options_contacts_name: "not found"})} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.name) !== "string") {outErr.push({customer_options_contacts_name: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.phone) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.phone) !== "string") {outErr.push({customer_options_contacts_phone: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.state) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.state) !== "string") {outErr.push({customer_options_contacts_state: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.website) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.website) !== "string") {outErr.push({customer_options_contacts_website: "type"})}
                                                    }
                                                    if (!apiData.data[item].customer.options.contacts.zip) {} else {
                                                        if (typeof(apiData.data[item].customer.options.contacts.zip) !== "string") {outErr.push({customer_options_contacts_zip: "type"})}
                                                    }
                                                    //-//
                                                }
                                            }
                                        }
                                    }
                                    //
                                }
                            }

                            if (!apiData.data[item].endTime) {
                                if (typeof(apiData.data[item].endTime) !== "string") {} else {
                                    if ((apiData.data[item].endTime).toString().length !== 24) {
                                        outErr.push({endTime: "length", value: apiData.data[item].endTime})
                                    }
                                }
                            }

                            if (!apiData.data[item].finOptions) {outErr.push({finOptions: "not found"})} else {
                                if (typeof(apiData.data[item].finOptions) !== "object") {outErr.push({finOptions: "type"})} else {
                                    //
                                    if (!apiData.data[item].finOptions.approvalCode) {} else {
                                        if (typeof(apiData.data[item].finOptions.approvalCode) !== "number") {outErr.push({finOptions_approvalCode: "type"})}
                                    }
                                    if (!apiData.data[item].finOptions.currency) {outErr.push({finOptions_currency: "not found"})} else {
                                        if (typeof(apiData.data[item].finOptions.currency) !== "string") {} else {
                                            // console.log(apiData.data[item].finOptions.currency.charCodeAt(0)) !!!
                                            // apiData.data[item].finOptions.currency.codePointAt(0) !!!
                                            if (([8376]).indexOf(apiData.data[item].finOptions.currency.charCodeAt(0)) === -1) {
                                                outErr.push({finOptions_currency: "value", value: apiData.data[item].finOptions.currency})
                                            }
                                        }
                                    }
                                    if (!apiData.data[item].finOptions.fullPrice) {outErr.push({finOptions_fullPrice: "not found"})} else {
                                        if (typeof(apiData.data[item].finOptions.fullPrice) !== "number") {outErr.push({finOptions_fullPrice: "type"})}
                                    }
                                    if (!apiData.data[item].finOptions.pricePerBillingPeriod) {} else {
                                        if (typeof(apiData.data[item].finOptions.pricePerBillingPeriod) !== "number") {} else {
                                            if (([null, 1, 30, 360, 365]).indexOf(apiData.data[item].customData.pricePerBillingPeriod) === -1) {
                                                outErr.push({finOptions_pricePerBillingPeriod: "value", value: apiData.data[item].finOptions.pricePerBillingPeriod})
                                            }
                                        }
                                    }
                                    if (!apiData.data[item].finOptions.priceSell) {outErr.push({finOptions_priceSell: "not found"})} else {
                                        if (typeof(apiData.data[item].finOptions.priceSell) !== "number") {outErr.push({finOptions_priceSell: "type"})}
                                    }
                                    if (!apiData.data[item].finOptions.realPrice) {outErr.push({finOptions_realPrice: "not found"})} else {
                                        if (typeof(apiData.data[item].finOptions.realPrice) !== "number") {outErr.push({finOptions_realPrice: "type"})}
                                    }
                                    //
                                }
                            }

                            if (!apiData.data[item].id) {outErr.push({id: "not found"})} else {
                                outId = apiData.data[item].id
                                if (typeof(apiData.data[item].id) !== "string") {outErr.push({id: "type"})} else {
                                    if ((apiData.data[item].id).toString().length !== 36) {
                                        outErr.push({id: "length", value: apiData.data[item].id})
                                    }
                                }
                            }

                            if (!apiData.data[item].options) {outErr.push({options: "not found"})} else {
                                if (typeof(apiData.data[item].options) !== "object") {outErr.push({options: "type"})} else {
                                    //
                                    if (!apiData.data[item].options.duration) {outErr.push({options_duration: "not found"})} else {
                                        if (typeof(apiData.data[item].options.duration) !== "number") {outErr.push({options_duration: "type"})} else {
                                            if (([1,30,360,365]).indexOf(apiData.data[item].options.duration) === -1) {
                                                outErr.push({options_duration: "value", value: apiData.data[item].options.duration})
                                            }
                                        }
                                    }
                                    if (!apiData.data[item].options.isB2c) {outErr.push({options_isB2c: "not found"})} else {
                                        if (typeof(apiData.data[item].options.isB2c) !== "boolean") {outErr.push({options_isB2c: "type"})} else {
                                        }
                                    }
                                    if (!apiData.data[item].options.isPayg) {} else {
                                        if (typeof(apiData.data[item].options.isPayg) !== "boolean") {outErr.push({options_isPayg: "type"})} else {
                                        }
                                    }
                                    if (!apiData.data[item].options.quantity) {outErr.push({options_quantity: "not found"})} else {
                                        if (typeof(apiData.data[item].options.quantity) !== "number") {outErr.push({options_quantity: "type"})} else {
                                            if (apiData.data[item].options.quantity <= 0 || apiData.data[item].options.quantity >= 2) {
                                                outErr.push({options_duration: "value", value: apiData.data[item].options.quantity})
                                            }
                                        }
                                    }
                                    if (!apiData.data[item].options.quantityChangeable) {outErr.push({options_quantityChangeable: "not found"})} else {
                                        if (typeof(apiData.data[item].options.quantityChangeable) !== "boolean") {outErr.push({options_quantityChangeable: "type"})} else {
                                        }
                                    }
                                    //
                                }
                            }

                            if (!apiData.data[item].productId) {outErr.push({productId: "not found"})} else {
                                if (typeof(apiData.data[item].productId) !== "string") {outErr.push({productId: "type"})} else {
                                    if ((apiData.data[item].productId).toString().length !== 36) {
                                        outErr.push({productId: "length", value: apiData.data[item].productId})
                                    }
                                }
                            }

                            if (!apiData.data[item].productName) {outErr.push({productName: "not found"})} else {
                                if (typeof(apiData.data[item].productName) !== "string") {outErr.push({productName: "type"})} else {
                                    if ((apiData.data[item].productName).toString().length < 10) {
                                        outErr.push({productName: "length", value: apiData.data[item].productName})
                                    }
                                }
                            }

                            if (!apiData.data[item].startTime) {outErr.push({createdAt: "not found"})} else {
                                if (typeof(apiData.data[item].startTime) !== "string") {outErr.push({startTime: "type"})} else {
                                    if ((apiData.data[item].startTime).toString().length !== 24) {
                                        outErr.push({startTime: "length", value: apiData.data[item].startTime})
                                    }
                                }
                            }

                            if (!apiData.data[item].status) {outErr.push({status: "not found"})} else {
                                if (typeof(apiData.data[item].status) !== "string") {outErr.push({status: "type"})} else {
                                    if ((['active','suspend']).indexOf(apiData.data[item].status) === -1) {
                                        outErr.push({status: "value", value: apiData.data[item].status})
                                    }
                                }
                            }

                            if (!apiData.data[item].trialTime) {
                                if (typeof(apiData.data[item].trialTime) !== "string") {outErr.push({trialTime: "type"})} else {
                                    if ((apiData.data[item].trialTime).toString().length !== 24) {
                                        outErr.push({trialTime: "length", value: apiData.data[item].trialTime})
                                    }
                                }
                            }

                            if (!apiData.data[item].updatedAt) {
                                if (typeof(apiData.data[item].updatedAt) !== "string") {outErr.push({updatedAt: "type"})} else {
                                    if ((apiData.data[item].updatedAt).toString().length !== 24) {
                                        outErr.push({updatedAt: "length", value: apiData.data[item].updatedAt})
                                    }
                                }
                            }

                            if (!apiData.data[item].vendorCode) {outErr.push({vendorCode: "not found"})} else {
                                if (typeof(apiData.data[item].vendorCode) !== "string") {outErr.push({vendorCode: "type"})} else {
                                    if ((['KSOS']).indexOf(apiData.data[item].vendorCode) === -1) {
                                        outErr.push({vendorCode: "value", value: apiData.data[item].vendorCode})
                                    }
                                }
                            }

                            if (outErr.length > 0) {
                                isBreak++
                            }
                        }
                    })
                }
            }
        } catch (_) {
            outErr = ['catch!', _]
        }
    }

    // console.log({apiCheckBlock: 'apiSubsCheck', id: outId, err_pack: outErr})
    if (outErr.length > 0) {
        apiAlert({apiCheckBlock: 'apiSubsCheck', first_id: outId, err_pack: outErr}, outCode).then(_ => {})
    }
}
/* 1.2. Изменить кол-во лиц */
let apiSubsQuantity = async (params) => {return await req({method: urlDefault + 'subscriptions/' + params.id + '/', body: {method: 'PUT', headers: hd, body: JSON.stringify(params.body)}})}

/* 2. Отчёты */
/* 2.1. Скачать отчёт */
let apiGetReport = async (params) => {return await req({method: (urlDefault + 'get-report?reportId=' + params.reportId + '&reportDate=' + params.reportDate + '-01'), body: {method: 'GET'}})}
/* 2.2. Список отчётов */
let apiGetReportList = async () => {return await req({method: (urlDefault + 'reports-list'), body: {method: 'GET'}})}

/* 3. Выгрузить CSV */
let apiGetReportCsv = async () => {return await req({method: (urlDefault + 'get-subscriptions-csv'), body: {method: 'GET'}})}


/* 4. Подключить подписку */
/* 4.1. Предложения */
let apiOffers = async (cache = true) => {
    let apiOffersExpired = 'apiOffersExpired'
    let apiOffersCache = 'apiOffersCache'
    let tileNow = Date.now()

    // Пытаемся получить из кэша
    if (cache) {
        try {
            let expired = localStorage.getItem(apiOffersExpired)
            if (expired && parseInt(expired) > tileNow) {
                let cached = localStorage.getItem(apiOffersCache)
                if (cached) {
                    return JSON.parse(cached)
                }
            }
        } catch (_) {
        }
    }

    // Делаем запрос
    let response = await req({method: (urlDefault + 'offers'), body: {method: 'GET'}})

    if (response.code === 200 && !!response.data && Object.keys(response.data).length > 0) {
        saveToLocalStorage(apiOffersExpired, tileNow + 28800 * 1000)
        saveToLocalStorage(apiOffersCache, response)
    }

    return response
}
/* 4.2. Подключаем */
let apiSubsAdd = async (params) => {return await req({method: urlDefault + 'subscriptions', body: {method: 'POST', headers: hd, body: JSON.stringify(params)}})}

/* 5. Компания */
/* 5.1. Параметры */
let apiMyEdit = async (params) => {return await req({method: urlDefault + 'set-company', body: {method: 'PUT', headers: hd, body: JSON.stringify(params)}})}
/* 5.2. Пользователи */
let apiUsersEdit = async (params) => {return await req({method: urlDefault + 'edit-user-list', body: {method: 'PUT', headers: hd, body: JSON.stringify(params)}})}
/* 5.3. Добавить пользователя */
let apiUsersAdd = async (params) => {return await req({method: urlDefault + 'add-user', body: {method: 'POST', headers: hd, body: JSON.stringify(params)}})}

/* 6. Профиль */
/* 6.1. Данные  */
let apiMy = async () => {
    if (!localStorage.getItem('authData')) {return fastAnswer401}

    const CACHE_KEY = 'myData_cache';
    const CACHE_DURATION = 1000; // кэш по собственным данным в пол часа

    // Функция для получения кешированных данных
    const getCachedData = () => {
        try {
            const cached = localStorage.getItem(CACHE_KEY);
            if (!cached) return null;

            const { response, timestamp } = JSON.parse(cached);
            const isExpired = Date.now() > timestamp;

            return isExpired ? null : response;
        } catch (error) {
            console.error('Cache read error:', error);
            return null;
        }
    };

    // Функция для сохранения данных в кеш
    const setCachedData = (data) => {
        if (([401]).indexOf(data.code) === -1) {
            const cacheData = {
                response: data,
                timestamp: Date.now() + CACHE_DURATION
            }

            try {
                localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData))
            } catch (error) {
                console.error('Cache write error:', error)
            }
        }
    }

    // Проверяем кеш
    const cachedResponse = getCachedData();
    if (cachedResponse) {
        return cachedResponse;
    }

    // Выполняем запрос если кеш пустой или истек
    const outVal = await req({method: urlDefault + 'me', body: {method: 'GET'}})

    // Сохраняем в кеш
    setCachedData(outVal);

    return outVal;
}
/* 6.2. Обновить */


let apiSelfEdit = async (params) => {return await req({method: urlDefault + 'edit-self-user', body: {method: 'PUT', headers: hd, body: JSON.stringify(params)}})}
/* 6.3. Сменить пароль */
let apiChangePassword = async (params) => {return await req({method: urlDefault + 'change-password', body: {method: 'PUT', headers: hd, body: JSON.stringify(params)}})}
let apiSubsStatus = async (params) => {return await req({method: urlDefault + 'subscriptions/' + params.id + '/' + params.status + '/', body: {method: 'PUT', headers: hd}})}
let apiSubsMail = async (params) => {return await req({method: urlDefault + 'send-mail', body: {method: 'POST', headers: hd, body: JSON.stringify(params)}})}
let apiUsers = async () => {return await req({method: (urlDefault + 'get-users'), body: {method: 'GET'}})}

const tryParseJsonPayload = (rawText) => {
    if (typeof rawText !== 'string') return rawText
    try {
        return JSON.parse(rawText)
    } catch (_) {
        return rawText
    }
}

let req = async (params = {}) => {
    let outData = fastAnswer500

    try {
        const response = await fetch(params.method, params.body)
        const status = response.status
        const contentType = response.headers.get('content-type')
        const isJsonResponse = (contentType || '').toLowerCase().includes('application/json')

        const clone = response.clone()
        const text = await clone.text()

        if (text.length === 0) {
            outData = {code: status, data: null}
        } else if (isJsonResponse) {
            try {
                const data = await response.json()
                outData = {code: status, data: data}
            } catch (_) {
                outData = {code: status, data: tryParseJsonPayload(text)}
            }
        } else {
            outData = {code: status, data: tryParseJsonPayload(text)}
        }

        if ((status + '').substr(0, 1) === '5') {
            if (params.method.split('/').pop() !== 'alert') {
                apiAlert(outData, status).then(_ => {})
            }
        }
    } catch (err) {
        if (params.method.split('/').pop() !== 'alert') {
            apiAlert(err).then(_ => {})
        }
    }

    return outData
}

export {
    apiAlert, apiExit, apiAuth, apiRecovery, apiNewPassword,
    apiMy, apiMyEdit, apiSelfEdit, apiChangePassword,

    apiSubs, apiSubsCheck,  apiSubsQuantity, apiSubsStatus, apiSubsMail, apiSubsAdd,
    apiOffers, apiUsers, apiUsersEdit, apiUsersAdd,

    apiGetReportList, apiGetReport, apiGetReportCsv
}
